import stringHelper from "../util/stringHelper";
import WorkOrderStatus from "./workOrderStatus";

const getBadgeClass = (workOrderStatus: WorkOrderStatus) => {
  let badgeTypeClass = "";

  switch (workOrderStatus) {
    case WorkOrderStatus.PendingDispatch:
    case WorkOrderStatus.DispatchedPendingAcceptance:
    case WorkOrderStatus.PendingAcceptance:
      badgeTypeClass = "bg-primary";
      break;

    case WorkOrderStatus.AcceptedPendingSchedule:
    case WorkOrderStatus.Scheduled:
      badgeTypeClass = "bg-info";
      break;

    case WorkOrderStatus.NotAvailableAnymore:
    case WorkOrderStatus.Declined:
      badgeTypeClass = "bg-danger";
      break;

    // case WorkOrderStatus.ServiceComplete:
    //   badgeTypeClass = "bg-success";
    //   break;

    default:
      break;
  }

  return "badge " + badgeTypeClass;
};

const getDisplayValue = (workOrderStatus: WorkOrderStatus) => {
  let displayValue = stringHelper.insertSpacesFromPascalCase(workOrderStatus);
  return displayValue;
};

const workOrderStatusHelper = {
  getBadgeClass,
  getDisplayValue,
};

export default workOrderStatusHelper;
